<!-- eslint-disable @angular-eslint/template/alt-text -->
<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div
  class="max-w-1xl mx-auto bg-white p-8 flex flex-col gap-4 rounded-lg shadow-lg"
>
  <div class="flex flex-wrap pb-4 justify-start">
    <img
      [routerLink]="['/physical-fitness/challenges']"
      class="left-arrow clickable"
      src="../../../../assets/icons/left-arrow.svg"
    />
    <h1 *ngIf="!isEditable" class="headeradminui-text pl-2">
      Create Fitness Challenges
    </h1>
    <h1 *ngIf="isEditable" class="headeradminui-text pl-2">
      Update Fitness Challenges
    </h1>
  </div>
  <nz-spin [nzSpinning]="pageLoading">
    <div *ngIf="isEditable" nz-row class="pt-4" nzJustify="end">
      <div nz-col>
        <button
          [disabled]="!viewForm"
          (click)="enableEdit()"
          nz-button
          nzType="primary"
        >
          Edit Challenges
        </button>
      </div>
    </div>
    <div class="flex flex-col gap-4">
      <div class="grid grid-cols-4 gap-4">
        <div class="flex flex-col w-full">
          <label class="form-label required">Active :</label>
          <nz-switch
            [nzDisabled]="isEditable && viewForm"
            [(ngModel)]="active"
          ></nz-switch>
        </div>
        <div class="flex flex-col w-full">
          <label class="form-label required">Visible :</label>
          <nz-switch
            [nzDisabled]="isEditable && viewForm"
            [(ngModel)]="visible"
          ></nz-switch>
        </div>
        <div class="flex flex-col w-full">
          <label class="form-label required">Testing :</label>
          <nz-switch
            [nzDisabled]="isEditable && viewForm"
            [(ngModel)]="isTest"
          ></nz-switch>
        </div>
        <div class="flex flex-col w-full">
          <label class="form-label required">Show Leaderboard :</label>
          <nz-switch
            [nzDisabled]="isEditable && viewForm"
            [(ngModel)]="showLeaderboard"
          ></nz-switch>
        </div>
      </div>
      <div class="grid grid-cols-2 gap-2">
        <div class="flex flex-col w-full">
          <label class="form-label required">Challenge Name :</label>
          <input
            nz-input
            placeholder="enter challenge name"
            [disabled]="isEditable && viewForm"
            [(ngModel)]="challengeName"
            type="text"
          />
        </div>
        <div class="flex flex-col w-full">
          <label class="form-label required"
            >Internal Challenge Name :
            <span
              nz-tooltip
              nzTooltipTitle="This is an internal identifier for the challenge, not visible to end users. Use lowercase and underscores, e.g. 'step_challenge_2024_june'"
            >
              <span nz-icon nzType="info-circle" nzTheme="outline"></span>
            </span>
          </label>
          <input
            nz-input
            placeholder="enter internal challenge name"
            [disabled]="isEditable && viewForm"
            [(ngModel)]="internalChallengeName"
            type="text"
            required
            [ngClass]="{ 'border-red-500': internalChallengeNameError }"
          />
          <div
            *ngIf="internalChallengeNameError"
            class="text-red-500 text-xs mt-1"
          >
            Internal Challenge Name is required and must follow the format:
            lowercase, underscore-separated.
          </div>
        </div>
        <div class="flex flex-col w-full">
          <label class="form-label required">Countdown (In Seconds) :</label>
          <input
            nz-input
            placeholder="enter countdown"
            [disabled]="isEditable && viewForm"
            [(ngModel)]="countDownInSec"
            type="number"
          />
        </div>
        <div class="flex flex-col w-full">
          <label class="form-label">Archive(!!usage deleted from app and admin portal) :</label>
          <nz-switch
            [nzDisabled]="isEditable && viewForm"
            [(ngModel)]="archive"
          ></nz-switch>
        </div>
      </div>
      <div class="grid grid-cols-2 gap-2">
        <div class="flex flex-col w-full">
          <label class="form-label required">Challenge Description :</label>
          <textarea
            nz-input
            placeholder="Enter challenge description"
            [disabled]="isEditable && viewForm"
            [(ngModel)]="description"
            rows="4"
          ></textarea>
        </div>
      </div>
      <div class="grid grid-cols-4 gap-4">
        <div class="flex flex-col w-full">
          <label class="form-label required">Selected Exercise:</label>
          <nz-select
            (ngModelChange)="selectExerciseData($event)"
            nzPlaceHolder="Please select exercise"
            [(ngModel)]="exerciseId"
            nzShowSearch
            [nzDisabled]="isEditable"
          >
            <nz-option
              *ngFor="let ex of exercisesOptions"
              [nzValue]="ex.value"
              [nzLabel]="ex.data"
            ></nz-option>
          </nz-select>
        </div>
      </div>
      <div class="flex gap-4" *ngIf="selectedExercise">
        <nz-card nzHoverable style="width: 440px" [nzCover]="coverTemplate">
          <nz-card-meta
            [nzTitle]="selectedExercise.title"
            [nzDescription]="selectedExercise.description"
          ></nz-card-meta>
          <h1 class="mt-2">Calories sent per rep : {{selectedExercise.calories}}</h1>
          <h1>Difficulty Level : {{selectedExercise.dif_level}}</h1>
          <h1>Body parts : {{selectedExercise.body_parts}}</h1>

        </nz-card>
        <ng-template #coverTemplate>
          <video #videoPlayer width="600" controls>
            <source [src]="this.selectedExercise.video_URL" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </ng-template>
      </div>
      <div class="grid grid-cols-4 gap-4">
        <div class="flex flex-col w-full">
          <label class="form-label">Applicable Partners:</label>
          <nz-select
            nzMode="multiple"
            nzPlaceHolder="Please select partners"
            [(ngModel)]="listOfSelectedValue"
            [nzDisabled]="isEditable && viewForm"
          >
            <nz-option
              *ngFor="let partner of partners"
              [nzValue]="partner.value"
              [nzLabel]="partner.data"
            ></nz-option>
          </nz-select>
        </div>
        <div class="flex flex-col w-full">
          <label class="form-label"
            >Applicable Users(this will always empty searched users will list
            here):</label
          >
          <nz-select
            nzMode="multiple"
            nzPlaceHolder="Please select users"
            [(ngModel)]="userIds"
            [nzDisabled]="isEditable && viewForm"
          >
            <nz-option
              *ngFor="let user of users"
              [nzValue]="user.value"
              [nzLabel]="user.data"
            ></nz-option
          ></nz-select>
        </div>
        <div class="flex flex-col w-full">
          <label class="form-label">Search Applicable Users:</label>
          <div nz-row>
            <div nz-col>
              <input
                class="w-[300px]"
                placeholder="Search Users"
                nz-input
                [(ngModel)]="selectedUser"
                (input)="onSearchUser($event)"
                (ngModelChange)="onUserSelect($event)"
                [nzAutocomplete]="auto"
                [disabled]="isEditable && viewForm"
              />
              <nz-autocomplete
                [nzDataSource]="userSearchResults"
                nzBackfill
                #auto
              ></nz-autocomplete>
            </div>
            <div nz-col>
              <nz-spin
                nzSimple
                [nzSpinning]="searchSpinner"
                [nzSize]="'small'"
              ></nz-spin>
            </div>
          </div>
        </div>
      </div>
      <div nz-row class="pt-4" nzJustify="end">
        <div nz-col>
          <button
            *ngIf="!isEditable"
            (click)="create()"
            nz-button
            nzType="primary"
          >
            Save Challenges
          </button>
          <button
            *ngIf="isEditable"
            [disabled]="isEditable && viewForm"
            (click)="update()"
            nz-button
            nzType="primary"
          >
            Update Challenges
          </button>
        </div>
      </div>
    </div>
  </nz-spin>
</div>
